/**
 * @description 為了讓畫面縮小時可以吃到手機的
 * Horizontal Scrolling
 */

const scroll = document.querySelector('#product_collapsed');
const scrollArr = scroll.querySelectorAll('ul');

scrollArr.forEach((element) => {
  ScrollMethod(element);
});

function ScrollMethod(dom) {
  let isDown = false;
  let scrollX;
  let scrollLeft;
  dom.addEventListener('mouseup', (e) => {
    isDown = false;
    dom.classList.remove('scroll');
  });
  dom.addEventListener('mouseleave', () => {
    isDown = false;
    dom.classList.remove('scroll');
  });
  dom.addEventListener('mousedown', (e) => {
    isDown = true;
    dom.classList.add('scroll');
    scrollX = e.pageX - dom.offsetLeft;
    scrollLeft = scroll.scrollLeft;
  });
  dom.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    let element = e.pageX - dom.offsetLeft;
    let scrolling = (element - scrollX) * 2;
    dom.scrollLeft = scrollLeft - scrolling;
    console.log(scrolling);
  });
}

/**
 * @description 手機板為了添加父層樣式
 */

$(document).ready(function () {
  const parents = $('#product_collapsed');
  const elements_mb = $('#product_collapsed > ul li a');

  // 依據路由呈現展開id
  // elements_mb.each(function() {
  // 	const href = $(this).attr("data-href")
  //   const id = $(this).attr('href')
  //   const hasCollapse = $(this).hasClass('collapse')
  // 	if(href && window.location.href.includes(href) && hasCollapse){
  // 		$(id).collapse('show')
  // 	}

  // })

  //收合父層添加父層樣式
  parents.on('shown.bs.collapse', function () {
    parents.addClass('mb-5');
  });
  parents.on('hidden.bs.collapse', function () {
    parents.removeClass('mb-5');
  });
});

/**
 * @description 為了添加樣式
 */

$(document).ready(function () {
  // 由路由添加PC樣式
  const elements_pc = $('.product-menu__list ul li a');
  elements_pc.each(function (index, item) {
    const href = $(this).attr('href');
    if (href && window.location.href.includes(href)) {
      $(this).parents('li').addClass('active');
    }
  });
  // 由路由添加父層樣式
  const elements_mb = $('.product-menu__list--mobile ul li a');
  elements_mb.each(function (index, item) {
    const href = $(this).attr('data-href');
    if (href && window.location.href.includes(href)) {
      $(this).parents('li').addClass('active');
    }
  });

  // 由路由添加MB子層樣式
  const elements_collapse = $('.product-menu__list--mobile .product-menu__submenu li a');
  elements_collapse.each(function (index, item) {
    const href = $(this).attr('href');
    if (href && window.location.href.includes(href)) {
      $(this).parents('li').addClass('active');
    }
  });

  const id = $('.collapse.product-menu__submenu li.active')
    .parents('.product-menu__submenu ')
    .attr('id');
  $(`[href='#${id}']`).parents('li').addClass('active');
  $(`#${id}`).collapse('show');
});
